const mimeTypeToExtensions = {
  // Изображения
  'image/jpeg': ['jpg', 'jpeg'],
  'image/jpg': ['jpg', 'jpeg'],
  'image/pjpeg': ['jpeg'],
  'image/png': ['png'],
  'image/webp': ['webp'],
  'image/gif': ['gif'],
  'image/bmp': ['bmp'],
  'image/tiff': ['tiff', 'tif'],
  'image/svg+xml': ['svg'],
  'image/x-icon': ['ico'],
  'image/heic': ['heic'],
  'image/heif': ['heif'],
  'image/avif': ['avif'],

  // Документы
  'application/pdf': ['pdf'],
  'application/msword': ['doc'],
  'application/vnd.openxmlformats-officedocument.wordprocessingml.document': [
    'docx',
  ],
  'application/vnd.ms-excel': ['xls'],
  'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet': ['xlsx'],
  'application/vnd.ms-powerpoint': ['ppt'],
  'application/vnd.openxmlformats-officedocument.presentationml.presentation': [
    'pptx',
  ],
  'text/plain': ['txt'],
  'text/csv': ['csv'],
  'application/rtf': ['rtf'],
  'application/vnd.oasis.opendocument.text': ['odt'],
  'application/vnd.oasis.opendocument.spreadsheet': ['ods'],
  'application/vnd.oasis.opendocument.presentation': ['odp'],

  // Архивы
  'application/zip': ['zip'],
  'application/x-rar-compressed': ['rar'],
  'application/x-7z-compressed': ['7z'],
  'application/x-tar': ['tar'],
  'application/gzip': ['gz'],
  'application/vnd.rar': ['rar'],

  // Аудио
  'audio/mpeg': ['mp3'],
  'audio/wav': ['wav'],
  'audio/ogg': ['ogg'],
  'audio/aac': ['aac'],
  'audio/flac': ['flac'],
  'audio/midi': ['mid', 'midi'],
  'audio/webm': ['weba'],
  'audio/opus': ['opus'],

  // Видео
  'video/mp4': ['mp4'],
  'video/mpeg': ['mpeg', 'mpg'],
  'video/webm': ['webm'],
  'video/ogg': ['ogv'],
  'video/quicktime': ['mov'],
  'video/x-msvideo': ['avi'],
  'video/x-matroska': ['mkv'],
  'video/x-flv': ['flv'],
  'video/3gpp': ['3gp'],
  'video/x-ms-wmv': ['wmv'],

  // Электронные книги
  'application/epub+zip': ['epub'],
  'application/x-mobipocket-ebook': ['mobi'],
  'application/vnd.amazon.ebook': ['azw'],

  // Web-технологии
  'text/html': ['html', 'htm'],
  'text/css': ['css'],
  'text/javascript': ['js', 'mjs'],
  'application/javascript': ['js', 'mjs'],
  'application/json': ['json'],
  'application/xml': ['xml'],
  'text/xml': ['xml'],
  'application/ld+json': ['jsonld'],

  // Системные
  'application/octet-stream': ['bin', 'exe', 'dll', 'dat'],
  'application/x-msdownload': ['exe', 'dll'],
  'application/x-shockwave-flash': ['swf'],

  // Шрифты
  'font/ttf': ['ttf'],
  'font/otf': ['otf'],
  'font/woff': ['woff'],
  'font/woff2': ['woff2'],
  'application/x-font-ttf': ['ttf'],

  // Базы данных и прочее
  'application/sql': ['sql'],
  'text/calendar': ['ics', 'ical'],
  'message/rfc822': ['eml', 'msg'],
}

/**
 * Функция для форматирования MIME-типов в расширения
 * @param mimeTypesString - строка с MIME-типами, разделенными запятыми: application/pdf,image/jpeg,image/png
 * @returns строка с расширениями, разделенными запятыми: pdf, jpg, png
 */
export function mimeToExtensionsString(
  mimeTypesString: string,
  separator = ', '
): string {
  const mimeTypes = mimeTypesString.split(',').map((m) => m.trim())
  const extensions = new Set()

  mimeTypes.forEach((mime) => {
    if (mimeTypeToExtensions[mime]) {
      mimeTypeToExtensions[mime].forEach((ext) => extensions.add(ext))
    }
  })

  return Array.from(extensions).sort().join(separator)
}
